import { gql } from "@apollo/client";

const UPDATE_TRAMO = gql`
    mutation updateTramo($input: AddTramoInput!, $idTramo: Int!){
        updateTramo(input: $input, idTramo: $idTramo) {
            idHonorarioProfesionalAjuste
        }
    }
`;

export default UPDATE_TRAMO;